export default "__VITE_ASSET__qF6WrSLh__"